import React from 'react';
import { motion } from 'framer-motion';
export function MinisterWelcome() {
  return <section className="py-16 bg-white border-b border-gray-100" data-id="element-274">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-275">
        <div className="text-center mb-12" data-id="element-276">
          <h2 className="text-3xl font-bold text-uganda-green mb-2" data-id="element-277">
            Welcome message from the Minister
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-278">
          {/* Minister Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full md:w-2/5 flex flex-col" data-id="element-279">
            <div className="w-full rounded-2xl overflow-hidden border-2 border-uganda-light-green shadow-lg bg-gray-100" data-id="element-280">
              <img src="https://cdn.magicpatterns.com/uploads/2avawG6XUnoaLV97aH7mKL/wmremove-transformed_(2).jpg" alt="Hon. Frank Tumwebaze" className="w-full h-full object-cover" data-id="element-281" />
            </div>
            <div className="mt-4 text-center" data-id="element-282">
              <h3 className="text-xl font-bold text-uganda-black" data-id="element-283">
                Hon. Frank Tumwebaze
              </h3>
              <p className="text-sm text-gray-500 font-medium" data-id="element-284">
                Minister of Agriculture, Animal Industry and Fisheries
              </p>
            </div>
          </motion.div>

          {/* Welcome Text */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full md:w-3/5 space-y-6 text-gray-700 leading-relaxed" data-id="element-285">
            <p data-id="element-286">
              Welcome to the official website of the Ministry of Agriculture,
              Animal Industry and Fisheries which doubles as the National
              Agricultural Sector Portal for the Republic of Uganda.
            </p>

            <p data-id="element-287">
              Visitors are welcome to explore this communication channel of the
              Ministry which complements stakeholder engagements, agricultural
              extension, publications and media features in showcasing work done
              within the guidance of the Vision of{' '}
              <strong className="text-uganda-green" data-id="element-288">
                "A Competitive, Profitable and Sustainable Agricultural Sector"
              </strong>{' '}
              and Mission{' '}
              <strong className="text-uganda-green" data-id="element-289">
                "To Transform Subsistence Farming into Commercial Agriculture."
              </strong>
            </p>

            <p data-id="element-290">
              Visitors are also welcome to explore the website for more
              information about the structure, mandate and functions of the
              Ministry of Agriculture, Animal Industry and Fisheries delivered
              through four Directorates, Departments and seven semi-autonomous
              Agencies.
            </p>

            <div className="bg-uganda-light-green p-6 rounded-xl border border-green-100 mt-6" data-id="element-291">
              <h4 className="font-bold text-uganda-black mb-3" data-id="element-292">
                Ministry Structure
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm" data-id="element-293">
                <div data-id="element-294">
                  <span className="font-semibold text-uganda-green block mb-2" data-id="element-295">
                    4 Directorates:
                  </span>
                  <ul className="list-disc list-inside space-y-1 text-gray-600" data-id="element-296">
                    <li data-id="element-297">Animal Resources</li>
                    <li data-id="element-298">Crop Resources</li>
                    <li data-id="element-299">Fisheries Resources</li>
                    <li data-id="element-300">Agricultural Extension Services</li>
                  </ul>
                </div>
                <div data-id="element-301">
                  <span className="font-semibold text-uganda-green block mb-2" data-id="element-302">
                    7 Agencies:
                  </span>
                  <p className="text-gray-600" data-id="element-303">
                    COCTU, CDOUGA, DDA, NAADS, NARO, NAGRC&DB, UCDA
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}